var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticClass: "main--gate"
  }, [_c('div', {
    staticClass: "gate__inner text-center w-100 h-lg-100 py-60 py-md-80 py-lg-50 white--text"
  }, [_c('v-container', [_c('div', {
    staticClass: "mb-30 mb-lg-64"
  }, [_c('h2', {
    staticClass: "tit--lg line-height-12 mb-16 mb-lg-28"
  }, [_vm._v(" 서울 용산시제품제작소 ")]), _c('p', {
    staticClass: "tit-txt mb-lg-4"
  }, [_vm._v(" 서울형 기술제조 창업 플랫폼을 통해 "), _c('strong', [_vm._v("제조기업")]), _vm._v("을 지원합니다. ")]), _c('p', {
    staticClass: "tit-txt"
  }, [_c('strong', [_vm._v("시장판매 목적 제품")]), _vm._v("의 공동개발, 제조, 교육을 지원합니다. ")])]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('gate-link', {
    attrs: {
      "href": "/",
      "target": "_blank",
      "tit": "전자제조 지원센터",
      "bgImage": "/images/gate/gate-link1.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('gate-link', {
    attrs: {
      "noLink": "",
      "tit": "모델링 지원센터",
      "bgImage": "/images/gate/gate-link2.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('gate-link', {
    attrs: {
      "href": "https://digital-blacksmithshop.com/",
      "target": "_blank",
      "tit": "디지털 대장간",
      "bgImage": "/images/gate/gate-link3.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "3"
    }
  }, [_c('gate-link', {
    attrs: {
      "href": "http://y-valley.org/",
      "target": "_blank",
      "tit": "Y-valley 상상가",
      "bgImage": "/images/gate/gate-link4.jpg"
    }
  })], 1)], 1)], 1)], 1), _c('footer', {
    staticClass: "footer w-100 py-30 py-lg-50"
  }, [_c('v-container', [_c('v-row', {
    staticClass: "flex-column-reverse flex-lg-row",
    attrs: {
      "align-lg": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "7",
      "xl": "6"
    }
  }, [_c('p', {
    staticClass: "footer__tit page-text font-weight-bold line-height-1 mb-8 mb-lg-14"
  }, [_vm._v(" 서울 용산 시제품제작소 ")]), _c('p', {
    staticClass: "footer__info"
  }, [_vm._v(" 서울특별시 용산구 청파로77 (원효전자상가6동) 2층, 3층 용산시제품제작소 (KEA) "), _c('br'), _vm._v(" TEL : 02-6388-6192"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "22px"
    }
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-md-none"
  }), _vm._v(" FAX : 070-7500-0095"), _c('span', {
    staticClass: "text-center d-none d-md-inline-block",
    staticStyle: {
      "width": "22px"
    }
  }, [_vm._v("|")]), _c('br', {
    staticClass: "d-block d-md-none"
  }), _vm._v(" EMAIL : yes@gokea.org ")])]), _c('v-col', {
    staticClass: "mb-20 mb-lg-0",
    attrs: {
      "cols": "12",
      "lg": "5",
      "xl": "6"
    }
  }, [_c('v-row', {
    staticClass: "ma-n4 ma-xl-n20",
    attrs: {
      "justify-lg": "end"
    }
  }, [_c('v-col', {
    staticClass: "pa-4 pa-xl-20",
    attrs: {
      "cols": "4",
      "xl": "auto"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/gate/partner-logo1.jpg",
      "max-width": "155"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4 pa-xl-20",
    attrs: {
      "cols": "4",
      "xl": "auto"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/gate/partner-logo2.jpg",
      "max-width": "155"
    }
  })], 1), _c('v-col', {
    staticClass: "pa-4 pa-xl-20",
    attrs: {
      "cols": "4",
      "xl": "auto"
    }
  }, [_c('v-img', {
    staticClass: "w-100",
    attrs: {
      "src": "/images/gate/partner-logo3.jpg",
      "max-width": "155"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }